import config from '~config';

import AuthGateway from './auth';
import DashboardGateway from './dashboard';
import CustomerGateway from './customer';
import GoldGateway from './gold';
import BranchGateway from './branch';
import SettingGateway from './setting';
import AdminGateway from './admin';
import ApprovalGateway from './approval';
import DiscountGateway from './discount';
import ProjectGateway from './project';
import SilverGateway from './silver';
import ReportGateway from './report';
import CustomerTransferGateway from './customerTransfer';

const baseUrl = config.baseUrl as string;

const auth = new AuthGateway(baseUrl);
const dashboard = new DashboardGateway(baseUrl);
const customer = new CustomerGateway(baseUrl);
const gold = new GoldGateway(baseUrl);
const branch = new BranchGateway(baseUrl);
const setting = new SettingGateway(baseUrl);
const admin = new AdminGateway(baseUrl);
const approval = new ApprovalGateway(baseUrl);
const discount = new DiscountGateway(baseUrl);
const project = new ProjectGateway(baseUrl);
const silver = new SilverGateway(baseUrl);
const report = new ReportGateway(baseUrl);
const customerTransfer = new CustomerTransferGateway(baseUrl);

export default {
    auth,
    dashboard,
    customer,
    gold,
    branch,
    setting,
    admin,
    approval,
    discount,
    project,
    silver,
    report,
    customerTransfer,
};
